var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualbreakImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 907,
    height: 380,
    viewBox: "0 0 907 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: -17,
    x2: 141.561,
    y2: -17,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 540.211 235.066)",
    stroke: "#8EC2FF",
    strokeWidth: 34,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: -11,
    x2: 147.561,
    y2: -11,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 295.007 187.166)",
    stroke: "#8EC2FF",
    strokeWidth: 22,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: -15,
    x2: 71.7062,
    y2: -15,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 695.912 191.07)",
    stroke: "#8EC2FF",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: -9.5,
    x2: 165.413,
    y2: -9.5,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 730.093 84.4619)",
    stroke: "#8EC2FF",
    strokeWidth: 19,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: -6,
    x2: 240.774,
    y2: -6,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 294.48 367.961)",
    stroke: "#8EC2FF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 752.363,
    y1: 265.699,
    x2: 589.027,
    y2: 208.952,
    stroke: "#8EC2FF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: -13,
    x2: 142.553,
    y2: -13,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 901.915 453.793)",
    stroke: "#8EC2FF",
    strokeWidth: 26,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 300.484,
    y2: -0.5,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 528.876 113.081)",
    stroke: "#8EC2FF",
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 300.484,
    y2: -0.5,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 760.252 390.879)",
    stroke: "#8EC2FF",
    strokeLinecap: "round"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 249.132,
    y2: -0.5,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 841.621 160.249)",
    stroke: "#8EC2FF",
    strokeLinecap: "round"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: -20,
    x2: 93.2447,
    y2: -20,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 423.261 311.193)",
    stroke: "#8EC2FF",
    strokeWidth: 40,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 27.5,
    y1: -27.5,
    x2: 50.5795,
    y2: -27.5,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 652.002 451.425)",
    stroke: "#8EC2FF",
    strokeWidth: 55,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: -25,
    x2: 68.7148,
    y2: -25,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 502.207 68.5596)",
    stroke: "#8EC2FF",
    strokeWidth: 50,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: -16,
    x2: 107.85,
    y2: -16,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 188.102 95.4316)",
    stroke: "#8EC2FF",
    strokeWidth: 32,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 367.444,
    y2: -1,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 364.759 333.531)",
    stroke: "#8EC2FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: -6.5,
    x2: 65.8801,
    y2: -6.5,
    transform: "matrix(-0.913008 -0.407941 -0.407941 0.913008 81.2373 151.007)",
    stroke: "#8EC2FF",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: -4,
    x2: 261.445,
    y2: -4,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 346.451 83.3418)",
    stroke: "#8EC2FF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualbreakImg);
export default __webpack_public_path__ + "static/media/visualbreak_img.e2396670069a4217b8e26b41e8d7f16a.svg";
export { ForwardRef as ReactComponent };